import React from 'react'

const Competitors = () => {
  return (
    <div>Competitors</div>
  )
}

export default Competitors